import { IconComponent } from '../icons/icon.component';
import { IconName } from '../icons/auto-generated/icon-name';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  input,
} from '@angular/core';

@Component({
  imports: [IconComponent],
  selector: 'mop-message',
  template: `
    @if (iconName(); as iconName) {
      <mop-icon [name]="iconName" class="me-2" aria-hidden="true"></mop-icon>
    }
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {
  type = input<'primary' | 'secondary'>('primary');
  icon = input<IconName>();
  customClasses = input<string>('');
  iconName = computed(() => {
    if (this.icon()) {
      return this.icon();
    }

    switch (this.type()) {
      case 'secondary':
        return 'help';
      default:
        return 'info';
    }
  });

  @HostBinding('class')
  get hostClasses(): string {
    return `message message-${this.type()} d-flex align-items-center ${this.customClasses()}`;
  }
}
